import { createElement, useState } from 'react';
import {
  Col,
  ModalBody,
  Nav,
  NavItem,
  Row,
  TabContainer,
} from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import Tooltip from 'components/tooltip/Tooltip';
import { SeasonalRuleModalTab } from './SeasonalRuleAddEditModal.constants';
import { SidebarNavStyled } from './SeasonalRuleAddEditModal.styles';
import CancellationPolicyTab from './tabs/CancellationPolicyTab';
import PropertyDetailsTab from './tabs/PropertyDetailsTab';

const sidebarTabs: { key: SeasonalRuleModalTab; disabled: boolean }[] = [
  { key: SeasonalRuleModalTab.PROPERTY_DETAILS, disabled: false },
  { key: SeasonalRuleModalTab.PRICE_RULES, disabled: true },
  { key: SeasonalRuleModalTab.CANCELLATION_POLICY, disabled: false },
];

const tabToComponent: Partial<Record<SeasonalRuleModalTab, () => JSX.Element>> =
  {
    [SeasonalRuleModalTab.PROPERTY_DETAILS]: PropertyDetailsTab,
    [SeasonalRuleModalTab.CANCELLATION_POLICY]: CancellationPolicyTab,
  };

const SeasonalRuleAddEditModalBody = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState<SeasonalRuleModalTab>(
    SeasonalRuleModalTab.PROPERTY_DETAILS,
  );
  const ActiveTabComponent = tabToComponent[activeTab];

  return (
    <ModalBody>
      <TabContainer
        activeKey={activeTab}
        onSelect={(key) => setActiveTab(key as unknown as SeasonalRuleModalTab)}
        id="seasonal-rule-modal-tabs"
      >
        <Row>
          <Col sm={3}>
            <SidebarNavStyled>
              <Nav stacked>
                {sidebarTabs.map(({ key, disabled }) => (
                  <NavItem
                    eventKey={key}
                    key={key}
                    disabled={disabled}
                    data-testid={`seasonal-rule-modal-tab-${key}`}
                  >
                    {key === SeasonalRuleModalTab.PRICE_RULES ? (
                      <Tooltip
                        id={`seasonal-rule-modal-tab-${key}-tooltip`}
                        text={t(
                          'pageProperty.seasonality.modal.comingSoonTooltip',
                        )}
                      >
                        {t(`pageProperty.seasonality.modal.tabs.${key}`)}
                      </Tooltip>
                    ) : (
                      t(`pageProperty.seasonality.modal.tabs.${key}`)
                    )}
                  </NavItem>
                ))}
              </Nav>
            </SidebarNavStyled>
          </Col>
          <Col sm={9}>
            {ActiveTabComponent && createElement(ActiveTabComponent)}
          </Col>
        </Row>
      </TabContainer>
    </ModalBody>
  );
};

export default SeasonalRuleAddEditModalBody;
